module.exports = __webpack_public_path__ + "img/yellowSapphire@2x.b53b203.png";